import Keycloak from "keycloak-js";
import Cookie from "js-cookie";

import { OAUTH_URL, REALM, CLIENT_ID, PUBLIC_URL } from "customGlobal";

export const COOKIE_TOKEN = "octal-token";
export const COOKIE_TOKEN_REFRESH = "octal-token-refresh";

const auth = new Keycloak({
  clientId: CLIENT_ID,
  realm: REALM,
  url: OAUTH_URL
});

export function initAuth() {
  return auth
    .init({
      onLoad: "login-required",
      checkLoginIframe: window.location.protocol === "https:",
      enableLogging: true,
      // on utilise l'ancien token en premier lors de l'initialisation
      // pour éviter une redirection si tout est bon.
      token: Cookie.get("octal-token"),
      refreshToken: Cookie.get("octal-token-refresh"),
      timeSkew: 0
    })
    .then(authenticated => {
      if (authenticated) {
        updateCookie();
      }
      return authenticated;
    });
}

export function updateToken() {
  return auth.updateToken(30).then(refreshed => {
    if (refreshed) {
      updateCookie();
    }

    return refreshed;
  });
}

function updateCookie() {
  // on sauvegarde en STRICT dans les cookies le token + token refresh.
  Cookie.set(COOKIE_TOKEN, auth.token || "", { expires: 1, sameSite: "strict", path: PUBLIC_URL });
  Cookie.set(COOKIE_TOKEN_REFRESH, auth.refreshToken || "", {
    expires: 1,
    sameSite: "strict",
    path: PUBLIC_URL
  });
}

window.addEventListener("storage", event => {
  if (event.key === "logout-event") {
    Cookie.remove(COOKIE_TOKEN, { path: PUBLIC_URL });
    Cookie.remove(COOKIE_TOKEN_REFRESH, { path: PUBLIC_URL });
    window.location.reload();
  }
});
/**
 * Méthode de déconnexion de l'application
 * - on revoke le token d'authentification
 * -
 */
export function disconnect() {
  // On enregistre l'event de logout pour deconnecter toutes les pages
  localStorage.setItem("logout-event", Date.now().toString());
  const redirectUrl = window.location.origin + PUBLIC_URL;
  sessionStorage.clear();
  // Nettoyer les cookies avant la déconnexion
  Cookie.remove(COOKIE_TOKEN, { path: PUBLIC_URL });
  Cookie.remove(COOKIE_TOKEN_REFRESH, { path: PUBLIC_URL });

  if (auth.token) {
    auth.logout({ redirectUri: redirectUrl });
  } else {
    window.location.href = redirectUrl;
  }
}

export function getAccountURI() {
  return auth.createAccountUrl();
}

(window as any).auth = auth;

export default auth;
